import React, { memo, useCallback, useState } from 'react';
import { createUseStyles, Input, Password, Text, Link, Button, Advice } from 'hoi-poi-ui';
import Cookies from 'js-cookie';
import { useWeb5Context } from "../../../lib/Web5Context";
import { getUserLoginRealm } from "../../../lib/services/auth";
import useLoginLiterals from "../../../lib/useLoginLiterals";
import { FadeTransition } from "../../../components/Transitions";
import AuthBox from "../components/AuthBox";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'Login');
const Login = _ref => {
  let {
    logo,
    onLogin,
    onAuthType,
    children,
    iframeURL,
    signupURL,
    recoverPasswordURL
  } = _ref;
  const {
    platform
  } = useWeb5Context();
  const classes = useStyles();
  const [username, setUsername] = useState(Cookies.get('username'));
  const [password, setPassword] = useState();
  const [error, setError] = useState();
  const [realm, setRealm] = useState();
  const [loginLoading, setLoginLoading] = useState();
  const {
    loading,
    t
  } = useLoginLiterals();
  const cleanRealm = useCallback(() => {
    setRealm(null);
  }, []);
  const nextStep = useCallback(e => {
    var _e$preventDefault;
    e === null || e === void 0 ? void 0 : (_e$preventDefault = e.preventDefault) === null || _e$preventDefault === void 0 ? void 0 : _e$preventDefault.call(e);
    const finalUsername = username === null || username === void 0 ? void 0 : username.trim();
    const finalPassword = password === null || password === void 0 ? void 0 : password.trim();
    if (loginLoading || !finalUsername) return;
    setLoginLoading(true);

    // Checking auth mode
    if (!realm) {
      const platformInt = parseInt(platform, 10);
      getUserLoginRealm({
        email: finalUsername,
        intDeviceType: platformInt,
        strClientVersion: platformInt === 101 ? 'WEB' : 'ADMIN'
      }).then(_ref2 => {
        let {
          data
        } = _ref2;
        const parsedData = JSON.parse(data);
        const result = parsedData === null || parsedData === void 0 ? void 0 : parsedData.Result;
        const authenticationType = result === null || result === void 0 ? void 0 : result.authenticationType;
        if (authenticationType >= 4) {
          return onAuthType && onAuthType(result);
        } else if (authenticationType === -1) {
          setRealm(authenticationType);
        }
      }).catch(e => {
        console.error(e);
        setError(t('error_generalerror'));
      }).finally(() => {
        setLoginLoading(false);
      });
    } else {
      onLogin(finalUsername, finalPassword).then(() => {
        Cookies.set('username', finalUsername);
      }).catch(e => {
        let error = 'error_generalerror';
        if (typeof e === 'string') error = e;
        setError(t(error));
      }).finally(() => {
        setLoginLoading(false);
      });
    }
    return false;
  }, [loginLoading, onAuthType, onLogin, password, platform, realm, t, username]);
  if (loading) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthBox, {
    title: t('title_welcome_forcemanager_login'),
    logo: logo,
    iframeURL: iframeURL ? t(iframeURL) : null
  }, /*#__PURE__*/React.createElement(FadeTransition, {
    transitionKey: "error",
    show: error
  }, /*#__PURE__*/React.createElement(Advice, {
    className: classes.error,
    type: "error",
    showIcon: true,
    defaultCollapsed: false,
    showCollapse: false
  }, error)), /*#__PURE__*/React.createElement("form", {
    onSubmit: nextStep
  }, /*#__PURE__*/React.createElement(Input, {
    label: t('label_email_or_mobile_login'),
    placeholder: t('label_email_or_mobile_login'),
    type: "text",
    id: "username",
    name: "username",
    autoComplete: "username",
    onFocus: cleanRealm,
    onChange: setUsername,
    value: username,
    isFullWidth: true,
    isDisabled: loginLoading,
    autoFocus: true
  }), /*#__PURE__*/React.createElement(FadeTransition, {
    transitionKey: "password",
    show: !!realm
  }, /*#__PURE__*/React.createElement(Password, {
    label: t('label_password'),
    id: "password",
    name: "password",
    autoComplete: "current-password",
    isFullWidth: true,
    onChange: setPassword,
    onEnter: nextStep,
    value: password,
    isDisabled: loginLoading,
    autoFocus: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.forgot
  }, /*#__PURE__*/React.createElement(Link, {
    href: recoverPasswordURL,
    type: "caption"
  }, t('action_question_forgot_password'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: nextStep,
    isLoading: loginLoading
  }, t('action_next')), signupURL && /*#__PURE__*/React.createElement("div", {
    className: classes.signup
  }, /*#__PURE__*/React.createElement(Text, null, t('helptext_are_you_still_not_a_member'), " "), /*#__PURE__*/React.createElement(Link, {
    href: signupURL,
    target: "_blank"
  }, t('action_start_free_trial_login')))))));
};
export default /*#__PURE__*/memo(Login);